import { get } from '../../../../infra/rest';
import requestConfig from '../../../../shared/config/request';
import { urlCreator } from '../../../../shared/utils/url-helpers';
import { GetCallConfigurationResponse } from '../typings';
import { CallPermisionsResponseType } from '../typings/chat';

export const getCallPermissionApi = async ({
  customerId,
  wabaNumber,
  signal,
}: {
  customerId: string;
  wabaNumber: string;
  signal?: AbortSignal;
}): Promise<CallPermisionsResponseType> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/call/call-permissions`,
    query: {
      customerId,
      wabaNumber,
    },
  });

  return get<CallPermisionsResponseType>(url, {}, true, false, true, false, false, signal);
};

export const getCallSettings = async (): Promise<GetCallConfigurationResponse> => {
  return get<GetCallConfigurationResponse>(
    `${requestConfig.aiBotBaseUrl}/v1/call/configuration`,
    undefined,
    true,
    false,
    true
  );
};
